import axios from '@/utils/axios'

const getShoppingCart = (query = { type: 'DirectMailCart' }, config) => axios.get('/api/v1/pc/shoppingCart', query, config)
/**
 * 修改指定商品数量
 * @param {*} data 
 * @param {*} config 
 * @returns 
 */
const changeCart = (data, config) => axios.put('/api/v1/pc/shoppingCart', data, config)
/**
 * 添加购物车（）
 * @param {*} data 
 * @param {*} config 
 * @returns 
 */
const addCart = (data, config) => axios.post('/api/v1/pc/shoppingCart', data, config)
/**
 * 同步数据并返回更新后的购物车数据
 * @param {*} data 
 * @param {*} config 
 * @returns 
 */
const updateCart = (type, data, config) => axios.post(`/api/v1/pc/shoppingcartUpdate?type=${type}`, data, config)
/**
 * 删除指定商品
 * @param {string} goodsId 
 * @param {Object} query 
 * @param {Object} config 
 * @returns 
 */
const removeCart = (goodsId, query, config) => axios.remove(`api/v1/pc/shoppingCart/${goodsId}`, query, config)

export default {
  getShoppingCart,
  changeCart,
  addCart,
  removeCart,
  updateCart,
}


// WEBPACK FOOTER //
// ./src/api/modules/cart.js